import React from 'react';

const CustomDropdownMenu = ({ style, children }) => (
  <ul
    className="ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light csv-options-menu"
    role="menu"
    tabIndex={0}
    style={style}
  >
    {children}
  </ul>
);

export default CustomDropdownMenu;
